<template>
	<div>
		<Header />
		<div class="content">
			<div class="w-1200 clearfix">
				<div class="bgc-c">
					<!-- <div class="block-block"></div> -->
					<img src="../assets/404.png" />
					<p class="p-t">您所访问的页面不存在</p>
					<p class="p-c">
						将在
						<span>3S</span>
						秒后为您跳转到首页
					</p>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>
<script>
	import Header from "../components/Header";
	import Footer from "../components/Footer";

	export default {
		name: "Nofound",
		components: {
			Header,
			Footer,
		},
		data() {
			return {};
		},
		methods: {},
	};
</script>
<style lang="less" scoped>
	.block-block {
		height: 190px;
		background: linear-gradient(180deg, rgba(245, 244, 250, 0) 0%, #F5F4FA 100%);
		opacity: .1;
		// margin-top: -130px;
		z-index: 99;
	}

	.bgc-c {
		background-color: #EFF3F8;
		margin-top: 70px;
	}

	img {
		margin-top: 70px;

	}

	.p-t {
		color: #2D2929;
		font-size: 24px;
		margin-top: 58px;
		font-weight: bold;
	}

	.p-c {
		color: #707070;
		font-size: 18px;
		margin-top: 12px;
		margin-bottom: 147px;

		span {
			color: #E13232;
		}
	}
</style>
